import { IExperiment } from 'shared/types/experiments';

export const isExperimentActive = (experiments: IExperiment[], experimentName: string, targetGroup: string) => {
  const experiment = experiments.find(e => e.experimentName === experimentName);

  if (experiment) {
    return experiment.groupName === targetGroup;
  }

  return false;
};
